<template>
  <UModal>
    <UCard>
      <template #header>
        <div class="flex justify-between">
          <div>
            <div class="font-bold text-2xl">
              <strong class="text-nowrap">Apri un ticket di assistenza</strong>
            </div>
          </div>
          <UButton
            color="white"
            variant="ghost"
            icon="i-heroicons-x-mark-20-solid"
            class="-my-1"
            @click="modal.close()"
          />
        </div>
      </template>
      <FeedbackForm />
    </UCard>
  </UModal>
</template>
<script setup lang="ts">
const modal = useModal();
</script>
